var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('v-card',[_c('v-card-text',[(_vm.data.translationKey)?_c('h1',[_vm._v(_vm._s(_vm.$t(`${_vm.data.translationKey}`)))]):_c('h1',[_vm._v(_vm._s(_vm.data.string))])])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }